export default "/_next/static/images/before-a17e1e43137d81e5ba77fc8309bade9c.png";